import { makeGetRequest, makePostRequest, makeDeleteRequest, makePutRequest } from 'utils/api'
import { Spend } from 'components/common/Spend'
import s from './ContactSpend.scss'

const ContactSpend = ({ id }) => {
  const makeSpendGetRequest = async () => id && (await makeGetRequest(`/v1/contacts/${id}/spend`))

  const makeSpendPostRequest = async itemDetails =>
    await makePostRequest(`/v1/contacts/${id}/spend`, itemDetails)

  const makeSpendPutRequest = async (itemId, itemDetails) =>
    await makePutRequest(`/v1/contacts/${id}/spend/item/${itemId}`, itemDetails)

  const makeSpendDeleteRequest = async itemId =>
    await makeDeleteRequest(`/v1/contacts/${id}/spend/item/${itemId}`)

  return (
    <div className={s.spendWrapper}>
      <Spend
        makeGetRequest={makeSpendGetRequest}
        makePostRequest={makeSpendPostRequest}
        makePutRequest={makeSpendPutRequest}
        makeDeleteRequest={makeSpendDeleteRequest}
      />
    </div>
  )
}

export default ContactSpend
